
<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px" transition="dialog-transition" scrollable v-if="can_import_forms" >
      <template v-slot:activator="{on}">
        <v-tooltip v-on="on" bottom color="black">
          <template v-slot:activator="{on}">
            <v-btn v-on="on" fab small color="secondary" :class="isMobile? 'mb-0' : ''" @click="dialog=true">
              <v-icon color="whtie">mdi-file-upload-outline</v-icon>
            </v-btn>
          </template>
          Importar Dados
        </v-tooltip>
      </template>

      <v-card style="border-radius:12px" v-if="dialog" :outlined="$vuetify.theme.isDark">
        <v-card-title primary-title class="pa-3 pb-2 pl-5">
          <div class="headline mb-0">Importar Usuários</div>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 pb-4">
          <v-form ref="dataImportForm">

            <template v-if="data_import.method_kind == 'creation'">
              <!-- botao de baixar arquivo padrao, index com filters -->
              <v-btn @click="downloadDefaultImportFile('User','creation')" small outlined color="success">baixar arquivo modelo para importar</v-btn>

              <v-row align='center' class="ma-0 my-5">
                <v-text-field
                  v-if="selected_department"
                  label="Departamentos"
                  :solo="!selected_department.map((dept) => dept.name).length" :outlined="selected_department.map((dept) => dept.name).length>0" dense flat hide-details
                  :value="selected_department.map((dept) => dept.name)"
                  prepend-icon="mdi-domain"
                  append-icon="mdi-close"
                  @click:append="selected_department = []"
                  readonly
                  class="mx-2 elevation-0"
                  color="secondary"
                ></v-text-field>
                
                <v-btn small color="secondary" @click="change_department = !change_department" >
                  {{change_department ? 'fechar' : selected_department ? 'alterar departamento' : 'selecionar departamento'}}
                </v-btn>
                
              </v-row>
              <v-alert
                v-if="!selected_department.length && no_department_alert"
                class="mt-3"
                type="error"
              >
                Selecione um departamento para prosseguir
              </v-alert>

              <template v-if="change_department">
                <v-subheader>Escolha os departamentos em que esse colaborador poderá atuar</v-subheader>
                <v-subheader>ATENÇÃO: O colaborador terá acesso à todos os subdepartamentos daqueles que selecionar</v-subheader>
                <card-loading v-if="!all_departments.length"></card-loading>
                <v-treeview
                  v-if="all_departments.length>0"
                  v-model="selected_department"
                  :items="all_departments"
                  dense
                  selectable
                  selected-color="light-green accent-4"
                  hoverable
                  color="primary"
                  return-object
                  shaped
                  ref="treeDepto"
                  selection-type="independent"
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon small class="ml-2">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                  </template>
                  <template v-slot:label="{ item, open, active }">
                    <span>{{item.name}}</span>
                  </template>
                </v-treeview>
              </template>
            </template>
  

            <v-file-input label='Arquivo' show-size
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
              v-model="data_import.imported_file" 
              :rules="required" 
              @click:clear="data_import.imported_file = null" 
              hint="Arquivos suportados: .xlsx"
              persistent-hint
              color="secondary"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end" >
          <v-btn @click="sendDataImport()" color="success" small>enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_msg"  max-width="700px" transition="dialog-transition" >
      <v-card style="border-radius:12px" :outlined="$vuetify.theme.isDark">
        <v-card-title primary-title class="pa-3 pu2">
          <div class="headline mb-0">{{redirect_to_page[redirect_to].text}}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class='py-0'>
          <v-row>
            <v-col class="pt-6">
              {{ msg }}
            </v-col>
          </v-row>
          <v-btn :to="redirect_to_page[redirect_to].page" color="secondary" small class="my-3">
            Ver {{redirect_to_page[redirect_to].text}} 
            <v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog_msg=false" color="secondary">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading" loadingText="Solicitando"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'
import validations from "@/mixins/validations";
import responsive from "@/mixins/responsive";
import conformity_result_map from "@/mixins/conformity_result_map";
// import DialogSelectDepartment from './DialogSelectDepartment.vue';


export default {
  name: 'DialogImportUsersFile',
  mixins: [validations, responsive, conformity_result_map],
  //mixins: [ validations ],
  components: {
    // DialogSelectDepartment,
    // DialogSelectFormsToDuplicate
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: false,

      data_import: {
        status: 'requested',
        ref_model_name: 'User', 
        format: 'xlsx',
        method_kind: 'creation', // 'duplication'
        params: {},
        imported_file: null,
      },

      loading: false,
      dialog_msg: false,
      msg: null,

      forms_selected: [],

      selected_department: [],
      change_department: false,
      no_department_alert: false,

      redirect_to_page: {
        import: {
          page: '/data_import',
          text: 'Importações',
        },
        export: {
          page: '/data_export',
          text: 'Exportações',
        }
      },
      redirect_to: 'import',
    }
  },
  methods: {
    downloadDefaultImportFile(ref_model_name, method_kind){
      if ( !this.loading ){
        this.loading = true
        let filter = {
          by_statuses: ['active'],
          by_kinds: method_kind,
          by_ref_model_name: ref_model_name,
        }
        Api.DefaultImportFile.index(filter).then(r=>r.data).then(d=> {
          if (d[0] && d[0].id){
            Api.DefaultImportFile.show(d[0].id).then(r=> r.data).then(f=> {
              window.open(f.file_url, '_blank');
            })
          }
          else {
            this.addNotification({msg: 'Desculpe, não encontramos o arquivo modelo. Contate o suporte', type: 'error'})
          }
        }).catch((error)=>{
          console.log({error});
          this.addNotification({msg: 'Desculpe, houve um erro para buscar o arquivo modelo. Contate o suporte', type: 'error'})
        }).finally(()=> {
          this.loading = false
        })
      }
    },
    sendDataImport(){
      if (this.$refs.dataImportForm.validate() && this.selected_department.length ){
        this.createDataImport()
      } else {
        if (!this.selected_department.length){
          this.no_department_alert = true;
          this.addNotification({msg: 'Necessário informar um departamento', type: 'error'})
        } else {
          this.addNotification({msg: 'Necessário enviar o arquivo', type: 'error'})
        }
      }
    },
    createDataImport(){
      this.loading = true
      this.data_import.params = {department_ids: this.selected_department.map(({id})=> id)}
      
      Api.DataImport.createFormData(this.data_import).then(r=> r.data).then(d=> {
        this.msg = 'Solicitação realizada, acesse a seção de importações para conferir se houve algum erro.'
        this.dialog = false
      }).catch(err=> {
        console.log(err.response.data.error)
        this.msg = err.response.data.error
      }).finally(()=> {
        this.dialog_msg = true
        this.loading = false
        this.redirect_to = 'import'
      })
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    active_solution_settings() {
      if (this.solutionID) {
        return this.allSolutions.find(o => o.id == Number(this.solutionID)).settings;
      }
    },
    can_import_forms() {
      if (this.active_solution_settings){
        const {
          allow_basic_import_forms,
          allow_import_massive_form_duplcation,
          allow_import_massive_schedule_creation
        } = this.active_solution_settings
        const can_import = allow_basic_import_forms || allow_import_massive_form_duplcation || allow_import_massive_schedule_creation 
        
        return can_import && this.$can("create", "Form");
      }
      return false
    },
    ...mapState({
      allSolutions: state => state.Solution.allSolutions,
      solutionID: state => state.Solution.solutionID,
      profile: state => state.User.oneUser,
      all_departments: state => state.Department.all_departments,
    }),
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.data_import = {
          ...this.data_import,
          status: 'requested',
          ref_model_name: 'User', 
          format: 'xlsx',
          method_kind: 'creation', // 'duplication'
          params: {},
          imported_file: null,
        }
        this.selected_department = []
      }
    }
  },
}
</script>

<style scoped>

</style>